import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MenuModule, Menu } from 'primeng/menu';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';

import { Fec } from '@shared/interfaces/fec';
import { FecFilter } from '@shared/interfaces/fecFilter';
import { FecService } from '@shared/services/fec.service';

import { ModalComponent } from '@shared/components/modal/modal.component';
import { PageContainerComponent } from '@shared/components/page-container/page-container.component';
import { GridContainerComponent } from '@shared/components/grid-container/grid-container.component';
import { FilterContainerComponent } from '@shared/components/filter-container/filter-container.component';
import { StatusChipComponent } from '@shared/components/status-chip/status-chip.component';
import { FecSummaryComponent } from '../fec-summary/fec-summary.component';
import { ApprovalFlowChipContainerComponent } from '@shared/components/approval-flow-chip-container/approval-flow-chip-container.component';
import { ChileanPesoPipe } from '@shared/pipes/chilean-peso.pipe';
import { CustomPercentPipe } from '@shared/pipes/custom-percent.pipe';
import { FecStatusEnum, FecStatusLabelEnum } from '@shared/enums/fecStatusEnum';

@Component({
  selector: 'app-fec-tracking',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PageContainerComponent,
    FilterContainerComponent,
    ButtonModule,
    GridContainerComponent,
    TableModule,
    MenuModule,
    ModalComponent,
    ApprovalFlowChipContainerComponent,
    FecSummaryComponent,
    InputTextModule,
    StatusChipComponent,
    ChileanPesoPipe,
    CustomPercentPipe,
    DropdownModule
  ],
  templateUrl: './fec-tracking.component.html',
  styleUrl: './fec-tracking.component.scss'
})
export class FecTrackingComponent implements OnInit {
  @ViewChild('approvalFlowView') approvalFlowView!: ModalComponent;
  @ViewChild('menu') menu?: Menu;

  paths = ['HOME', 'Aprobación FEC', 'Mis FEC']
  records!: Fec[];
  totalRecords: number = 0;
  loading: boolean = false;

  statusList = Object.entries(FecStatusLabelEnum)
    .map(([key, value]) => ({ name: value, value: key })).filter(item => item.value !== FecStatusEnum.DRAFT);

  public form: FormGroup = this.fb.group({
    rut: [''],
    clientName: [''],
    comercialName: [''],
    fecStatus: [''],
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private fecService: FecService
  ) {}

  ngOnInit() {
    this.onSearch({ first: 0, rows: 10 });
  }

  onSearch(params: TableLazyLoadEvent) {
    this.loading = true;
    this.fecService.pagedFindFec({
      filters: {...this.form.value, useUserSession: true, notFecStatus: FecStatusEnum.DRAFT} as FecFilter,
      first: params.first ?? 0,
      rows: params.rows ?? 10
    }).subscribe((resp) => {
      this.records = resp.list;
      this.totalRecords = resp.total;
      this.loading = false;
    });
  }

  onRowCheckPreview(item: Fec, index: number) {
    return this.router.navigate(['/read-only-fec'], { queryParams: {id: item.id}});
  }

}
